module.exports = __webpack_public_path__ + "img/xinshuai.3ff64997.jpg";